import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  currentYear: number = new Date().getFullYear();
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts